module.exports = __webpack_public_path__ + "static/img/icon_locate@2x.02c8011d.png";